export const haveISeenItKey = 'admin-manages-account-banner';

// We need that constant date to not show the notification banner for all the users
// who already received a similar email notification before that date, to avoid confusion.
export const startShowingBannerDate = '2021-04-29T00:00:00.000Z';
